import type { CryptoCurrency, FiatCurrency, Nft } from '@0xtorch/core'

export const createAssetKey = (
  asset: CryptoCurrency | FiatCurrency | Nft,
): string => `${asset.type}/${asset.id}`
